<template>
  <div>
    <PageTable />
  </div>
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'plan-pdCostsOrder',
  components: { PageTable },
}
</script>
